// Trimmed from weco-dashboard/src/server.js: this app only needs Google SSO,
// the MQTT credentials it unlocks, and one device's display name -- no
// WEC-fleet management, no settings, no picture-taking commands. This is a
// read-only demo and must never gain a call that publishes/writes anything.

export const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:5000';

export async function authenticate(token) {
  const response = await fetch(SERVER_URL + '/authenticate', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ token }),
    credentials: 'include',
  });

  if (!response.ok) throw new Error(response.statusText);
  return await response.json();
}

export async function login() {
  const response = await fetch(SERVER_URL + '/login', { credentials: 'include' });

  if (!response.ok) throw new Error(response.statusText);
  return await response.json();
}

export async function getMqttCredentials() {
  const response = await fetch(SERVER_URL + '/get_mqtt_credentials', { credentials: 'include' });

  if (!response.ok) throw new Error(response.statusText);
  return await response.json();
}

export async function getWecs() {
  const response = await fetch(SERVER_URL + '/wecs', { credentials: 'include' });

  if (!response.ok) throw new Error(response.statusText);
  return await response.json();
}

export async function getPictureList() {
  const response = await fetch(SERVER_URL + '/get_picture_list', { credentials: 'include' });

  if (!response.ok) throw new Error(response.statusText);
  return await response.json();
}

export async function getSignedUrl(filename) {
  const response = await fetch(SERVER_URL + '/get_signed_url/' + filename, { credentials: 'include' });

  if (!response.ok) throw new Error(response.statusText);
  return await response.text();
}
